import NoSsr from '@material-ui/core/NoSsr';
import { useEffect, useState } from 'react';
import calculateTimeLeft from 'utils/calculateTimeLeft';

// thuannc
// TODO:
// MUST FIX

function CountdownTimerVoucher({ prefix, dealEndDay, typeSpace = ' ', textExpired = 'Đã hết hạn', ...otherProps }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(dealEndDay));

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(dealEndDay));
    }, 1000);
    return () => clearTimeout(timer);
  });

  const timerComponents = [];
  Object.keys(timeLeft).forEach((interval) => {
    const val = timeLeft[interval];
    if (!val) {
      return;
    }
    // 05Jan2022 -> nếu > 30 ngày thì set lại 30 ngày, dài quá bể UI

    timerComponents.push(
      <span key={`timer-${Math.random()}`}>
        {val}
        {interval === 'days' ? ` ngày${typeSpace}` : null}
      </span>,
    );
  });

  return (
    <NoSsr>
      <div {...otherProps}>
        {prefix}
        {
          timerComponents?.length ? 'Còn ' : ''
        }
        {timerComponents.length ? timerComponents : <span>{textExpired}</span>}
      </div>
    </NoSsr>
  );
}

export default CountdownTimerVoucher;
